import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { IDhlCredentialsModel } from '../../../../../../models/IntegrationsTypes';

class DhlCredentialsStore implements ICredentialsStore {
    private _changes: IDhlCredentialsModel = {} as IDhlCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get internalName() { return this._changes.internal_name; };
    public get apiKey() { return this._changes.api_key; };
    public get apiSecret() { return this._changes.api_secret; };
    public get customerNumber() { return this._changes.customer_number; };
    public get vatNumber() { return this._changes.vat_number; };
    public get eoriNumber() { return this._changes.eori_number; };
    public get dutiesTaxesAccountNumber() { return this._changes.duties_taxes_account_number; };

    setInternalName(value: string) {
        this._changes.internal_name = value;
    };

    setApiKey(value: string) {
        this._changes.api_key = value;
    };

    setApiSecret(value: string) {
        this._changes.api_secret = value;
    };

    setCustomerNumber(value: string) {
        this._changes.customer_number = value;
    };

    setVatNumber(value: string) {
        this._changes.vat_number = value;
    };

    setEoriNumber(value: string) {
        this._changes.eori_number = value;
    };

    setDutiesTaxesAccountNumber(value: string) {
        this._changes.duties_taxes_account_number = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default DhlCredentialsStore;
